export const machineObjectName = "machine";
export const machineConfigurationObjectName = "machineConfiguration";
export const machineEpromConfigurationObjectName = "machineEpromConfiguration";
export const machineGameConfigurationObjectName = "machineGameConfiguration";
